import { isNull, isNullOrUndefined, isFunction, error, isEventProp, isArray, isNumber, isString, throwError, isInvalid, isObject, isStringOrNumber, EMPTY_OBJ, isUndefined, hasDocumentAvailable } from 'intact-shared';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function normalizeEventName(name) {
    return name.substr(3);
}
function replaceChild(parentDom, newDom, lastDom) {
    parentDom.replaceChild(newDom, lastDom);
}
function setTextContent(dom, children) {
    dom.textContent = children;
}
function removeChild(parentDom, dom) {
    parentDom.removeChild(dom, true);
}
function insertOrAppend(parentDom, newNode, anchor) {
    if (isNull(anchor)) {
        parentDom.appendChild(newNode);
    }
    else {
        parentDom.insertBefore(newNode, anchor);
    }
}
var REFERENCE = { value: false };
var Fragment = '$F';
function removeVNodeDom(vNode, parentDom) {
    var type;
    var dom;
    do {
        type = vNode.type;
        if (type & 3043 /* HtmlElement */) {
            var transition = vNode.transition;
            if (isNullOrUndefined(transition)) {
                removeChild(parentDom, vNode.dom);
            }
            else {
                dom = vNode.dom;
                transition.leave(dom, function () { return removeChild(parentDom, dom); });
            }
            return;
        }
        var children = vNode.children;
        if (type & 8 /* ComponentClass */) {
            vNode = children.$lastInput;
        }
        else if (type & 16 /* ComponentFunction */) {
            vNode = children;
        }
        else if (type & 4096 /* Fragment */) {
            if (vNode.childrenType === 2 /* HasVNodeChildren */) {
                vNode = children;
            }
            else {
                for (var i = 0; i < children.length; i++) {
                    removeVNodeDom(children[i], parentDom);
                }
                return;
            }
        }
    } while (vNode);
}
function findDomFromVNode(vNode, startEdge) {
    var type;
    while (vNode) {
        type = vNode.type;
        if (type & 3043 /* HtmlElement */) {
            return vNode.dom;
        }
        vNode = findChildVNode(vNode, startEdge, type);
    }
    return null;
}
function findChildVNode(vNode, startEdge, type) {
    var children = vNode.children;
    if (type & 8 /* ComponentClass */) {
        return children.$lastInput;
    }
    if (type & 4096 /* Fragment */) {
        return vNode.childrenType === 2 /* HasVNodeChildren */ ?
            children :
            children[startEdge ? 0 : children.length - 1];
    }
    return children;
}
function findDomsFromVNode(vNode) {
    while (vNode) {
        var type = vNode.type;
        if (type & 3043 /* HtmlElement */) {
            return vNode.dom;
        }
        if (type & 4096 /* Fragment */) {
            var children = vNode.children;
            if (vNode.childrenType === 2 /* HasVNodeChildren */) {
                vNode = children;
                continue;
            }
            else {
                var fragment = document.createDocumentFragment();
                for (var i = 0; i < children.length; i++) {
                    fragment.appendChild(findDomsFromVNode(children[i]));
                }
                return fragment;
            }
        }
        if (type & 8 /* ComponentClass */) {
            vNode = vNode.children.$lastInput;
            continue;
        }
        vNode = vNode.children;
    }
}
function moveVNodeDom(vNode, parentDom, anchor) {
    do {
        var type = vNode.type;
        if (type & 3043 /* HtmlElement */) {
            // TODO: move with transtion
            insertOrAppend(parentDom, vNode.dom, anchor);
            return;
        }
        var children = vNode.children;
        if (type & 8 /* ComponentClass */) {
            vNode = children.$lastInput;
        }
        else if (type & 16 /* ComponentFunction */) {
            vNode = children;
        }
        else if (type & 4096 /* Fragment */) {
            if (vNode.childrenType === 2 /* HasVNodeChildren */) {
                vNode = children;
            }
            else {
                for (var i = 0; i < children.length; i++) {
                    moveVNodeDom(children[i], parentDom, anchor);
                }
                return;
            }
        }
    } while (vNode);
}
function getComponentName(tag) {
    return tag.name || tag.displayName; // || tag.constructor.name || (tag.toString().match(/^function\s*([^\s(]+)/) || [])[1];
}
function callAll(mountedQueue) {
    if (process.env.NODE_ENV !== 'production') {
        if (Object.isFrozen(mountedQueue)) {
            throw new Error('Call the same mountedQueue again becasue it is frozen. Please create a issue for Intact.');
        }
    }
    // add a mountedQueue.i property, see mountRef function
    for (var i = mountedQueue.i = 0; i < mountedQueue.length; i++) {
        mountedQueue.i++;
        mountedQueue[i]();
    }
    if (process.env.NODE_ENV !== 'production') {
        mountedQueue.done = true;
        Object.freeze(mountedQueue);
    }
}
var xlinkNS = "http://www.w3.org/1999/xlink";
var xmlNS = "http://www.w3.org/XML/1998/namespace";
var namespaces = {
    'xlink:href': xlinkNS,
    'xlink:arcrole': xlinkNS,
    'xlink:actuate': xlinkNS,
    'xlink:show': xlinkNS,
    'xlink:role': xlinkNS,
    'xlink:title': xlinkNS,
    'xlink:type': xlinkNS,
    'xml:base': xmlNS,
    'xml:lang': xmlNS,
    'xml:space': xmlNS,
};
var hooks = {
    beforeInsert: null,
};

function throwIfObjectIsNotVNode(vNode) {
    if (!isNumber(vNode.type)) {
        throwError("normalization received an object that's not a valid VNode," +
            " you should stringify it first or fix createVNode type." +
            " Object: \"".concat(JSON.stringify(vNode), "\"."));
    }
}
function validateVNodeElementChildren(vNode) {
    if (vNode.childrenType & 1 /* HasInvalidChildren */) {
        return;
    }
    if (vNode.type & 3043 /* HtmlElement */) {
        var voidTypes = {
            area: true,
            base: true,
            br: true,
            col: true,
            command: true,
            embed: true,
            hr: true,
            img: true,
            input: true,
            textarea: true,
            keygen: true,
            link: true,
            meta: true,
            param: true,
            source: true,
            track: true,
            wbr: true,
            media: true,
        };
        var tag = vNode.tag.toLowerCase();
        if (voidTypes[tag]) {
            throwError("".concat(tag, " elements can't have children."));
        }
    }
}
function validateKeys(vNode) {
    if (process.env.NODE_ENV !== 'production') {
        // Checks if there is any key missing or duplicate keys
        if (!vNode.isValidated && vNode.children && vNode.type & 2 /* CommonElement */) {
            var error_1 = getValidateKeysError(isArray(vNode.children) ? vNode.children : [vNode.children], (vNode.childrenType & 8 /* HasKeyedChildren */) > 0);
            if (error_1) {
                throwError(error_1 + getTagName(vNode));
            }
        }
        vNode.isValidated = true;
    }
}
function getValidateKeysError(vNodes, forceKeyed) {
    var foundKeys = {};
    for (var i = 0; i < vNodes.length; i++) {
        var vNode = vNodes[i];
        if (isArray(vNode)) {
            return 'Encounterd ARRAY in mount, array must be flattened, or normalize used. Location: \n' + getTagName(vNode);
        }
        if (isInvalid(vNode)) {
            if (forceKeyed) {
                return 'Encountered invalid node when preparing to keyed algorithm. Location: \n' + getTagName(vNode);
            }
            else if (Object.keys(foundKeys).length !== 0) {
                return 'Encountered invalid node with mixed keys. Location: \n' + getTagName(vNode);
            }
            continue;
        }
        if (isObject(vNode)) {
            if (vNode.isValidated) {
                continue;
            }
            vNode.isValidated = true;
        }
        var key = vNode.key;
        if (!isNullOrUndefined(key) && !isStringOrNumber(key)) {
            return 'Encountered child vNode where key property is not string or number. Location: \n' + getTagName(vNode);
        }
        var children = vNode.children, childrenType = vNode.childrenType;
        if (!isInvalid(children)) {
            var error_2 = void 0;
            if (childrenType & 12 /* MultipleChildren */) {
                error_2 = getValidateKeysError(children, (childrenType & 8 /* HasKeyedChildren */) !== 0);
            }
            else if (childrenType === 2 /* HasVNodeChildren */) {
                error_2 = getValidateKeysError([children], false);
            }
            if (error_2) {
                return error_2 + getTagName(vNode);
            }
        }
        if (forceKeyed && isNullOrUndefined(key)) {
            return 'Encountered child without key during keyed algorithm. If this error points to Array make sure children is flat list. Location: \n' + getTagName(vNode);
        }
        else if (!forceKeyed && isNullOrUndefined(key)) {
            if (Object.keys(foundKeys).length !== 0) {
                return 'Encountered children with key missing. Location: \n' + getTagName(vNode);
            }
            continue;
        }
        if (foundKeys[key]) {
            return 'Encountered two children with same key: {' + key + '}. Location: \n' + getTagName(vNode);
        }
        foundKeys[key] = true;
    }
}
function getTagName(vNode) {
    var tagName;
    if (isArray(vNode)) {
        var arrayText = vNode.length > 3 ? vNode.slice(0, 3).toString() + ',...' : vNode.toString();
        tagName = "Array(".concat(arrayText, ")");
    }
    else if (isStringOrNumber(vNode)) {
        tagName = "Text(".concat(vNode, ")");
    }
    else if (isInvalid(vNode)) {
        tagName = "InvalidVNode(".concat(vNode, ")");
    }
    else {
        var type = vNode.type;
        if (type & 962 /* Element */) {
            tagName = "<".concat(vNode.tag).concat(vNode.className ? " class=\"".concat(vNode.className, "\"") : '', ">");
        }
        else if (type & 1 /* Text */ || type & 2048 /* Void */) {
            tagName = "Text(".concat(vNode.children, ")");
        }
        else if (type & 32 /* HtmlComment */) {
            tagName = "Comment(".concat(vNode.children, ")");
        }
        else {
            tagName = "<".concat(getComponentName(vNode.tag), " />");
        }
    }
    return ">> ".concat(tagName, "\n");
}
// @reference Vue
function validateProps(vNode) {
    var tag = vNode.tag;
    var typeDefs = tag.typeDefs;
    var componentName = getComponentName(tag);
    var props = vNode.props;
    if (isNullOrUndefined(props) || isNullOrUndefined(typeDefs))
        return;
    for (var prop in __assign(__assign({}, props), typeDefs)) {
        var value = props[prop];
        var expectedType = typeDefs[prop];
        if (!isPlainObject(expectedType)) {
            expectedType = { type: expectedType };
        }
        if (isNullOrUndefined(value)) {
            var required = expectedType.required;
            if (isFunction(required)) {
                required = required(props);
            }
            if (required) {
                error("Missing required prop on component \"".concat(componentName, "\": \"").concat(prop, "\"."));
                return;
            }
            continue;
        }
        var type = expectedType.type;
        if (isNullOrUndefined(type) && isEventProp(prop)) {
            type = Function;
        }
        if (!isNullOrUndefined(type)) {
            if (!isArray(type)) {
                type = [type];
            }
            var _valid = false;
            var _isStringOrNumber = false;
            var expectedTypes = [];
            for (var i = 0; i < type.length; i++) {
                var t = type[i];
                if (isNullOrUndefined(t))
                    continue;
                var _a = assertType(value, t), expectedType_1 = _a.expectedType, valid = _a.valid, isStringOrNumber_1 = _a.isStringOrNumber;
                expectedTypes.push(expectedType_1 || '');
                _isStringOrNumber = isStringOrNumber_1;
                if (valid) {
                    _valid = valid;
                    break;
                }
            }
            if (!_valid) {
                error("Invalid type of prop \"".concat(prop, "\" on component \"").concat(componentName, "\". ") +
                    "Expected ".concat(expectedTypes.join(', '), ", but got ") +
                    "".concat(toRawType(value, _isStringOrNumber), "."));
                return;
            }
        }
        var validator = expectedType.validator;
        if (validator) {
            var result = validator(value);
            if (result === false) {
                error("Invalid prop \"".concat(prop, "\" on component \"").concat(componentName, "\": custom validator check failed."));
            }
            else if (result !== true) {
                error("Invalid prop \"".concat(prop, "\" on component \"").concat(componentName, "\": ").concat(result));
            }
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;
function assertType(value, type) {
    if (isNumber(type)) {
        return { valid: type === value, expectedType: type, isStringOrNumber: true };
    }
    else if (isString(type)) {
        return { valid: type === value, expectedType: "\"".concat(type, "\""), isStringOrNumber: true };
    }
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (valid && t === 'number' && value !== value) {
            // for NaN
            valid = false;
        }
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        valid = value instanceof type;
    }
    return { valid: valid, expectedType: expectedType, isStringOrNumber: false };
}
function getType(type) {
    var match = type && type.toString().match(/^\s*(?:function|class) (\w+)/);
    return match ? match[1] : '';
}
var toString = Object.prototype.toString;
function toRawType(value, isStringOrNumber) {
    if (isStringOrNumber) {
        if (isString(value)) {
            return "\"".concat(value, "\"");
        }
        return value;
    }
    if (value !== value)
        return 'NaN';
    return toString.call(value).slice(8, -1);
}
function isPlainObject(value) {
    return toString.call(value) === '[object Object]';
}

var VNode = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function () {
    function VNode(type, tag, childrenType, children, className, props, key, ref) {
        this.dom = null;
        this.type = type;
        this.tag = tag;
        this.childrenType = childrenType;
        this.children = children;
        this.className = className;
        this.props = props;
        this.key = key === undefined ? null : key;
        this.ref = ref === undefined ? null : ref;
        // for Transition
        this.transition = null;
        // FIXME: Is it necessary to initialize these properties to prevent V8 from de-optimization
        this.position = null;
        this.newPosition = null;
        // for setScopeId in vue
        this.hooks = null;
        if (process.env.NODE_ENV !== 'production') {
            this.isValidated = false;
            Object.freeze(props);
        }
    }
    return VNode;
}());
// export function createVNode<
// T extends ComponentConstructor<U>,
// U extends ComponentClass<P>,
// P extends {}
// >(
// tag: T,
// props?: Props<P, U> | null,
// children?: Children | null
// ): VNodeComponentClass<U>;
// export function createVNode<
// T extends ComponentFunction<P, R>,
// P extends {},
// R extends Element | ComponentClass
// >(
// tag: T,
// props: Props<P, R> | null,
// children?: Children | null
// ): VNodeComponentFunction<T>;
// export function createVNode<T extends string>(
// tag: T,
// props?: Props<any, Element> | null,
// children?: Children | null
// ): VNode<T>;
function createVNode(tag, props, children) {
    var type;
    var isElement = false;
    switch (typeof tag) {
        case 'string':
            isElement = true;
            type = getTypeForVNodeElement(tag);
            break;
        case 'function':
            type = 4 /* ComponentUnknown */;
            break;
        default:
            throwError("createVNode expects to get a string or function, but get a type: \"".concat(JSON.stringify(tag), "\""));
    }
    var key = null;
    var ref = null;
    var newProps = null;
    var className = null;
    if (!isNullOrUndefined(props)) {
        for (var prop in props) {
            if (isElement && prop === 'className') {
                className = props.className;
            }
            else if (prop === 'key') {
                key = props.key;
            }
            else if (prop === 'ref') {
                ref = props.ref;
            }
            else if (prop === 'children') {
                children = props.children;
            }
            else {
                if (isNullOrUndefined(newProps))
                    newProps = {};
                newProps[prop] = props[prop];
            }
        }
    }
    if (isElement) {
        if (type & 4096 /* Fragment */) {
            return createFragment(children, 0 /* UnknownChildren */, key);
        }
        return createElementVNode(type, tag, children, 0 /* UnknownChildren */, className, newProps, key, ref);
    }
    var hasChildren = !isNullOrUndefined(children);
    var hasKey = !isNullOrUndefined(key);
    if (hasChildren || hasKey || ref) {
        if (isNullOrUndefined(newProps))
            newProps = {};
        if (hasChildren)
            newProps.children = children;
        if (hasKey)
            newProps.key = key;
        if (ref)
            newProps.ref = ref;
    }
    return createComponentVNode(type, tag, newProps, key, ref);
}
function getTypeForVNodeElement(tag) {
    switch (tag) {
        case 'input':
            return 64 /* InputElement */;
        case 'select':
            return 128 /* SelectElement */;
        case 'textarea':
            return 256 /* TextareaElement */;
        case 'svg':
            return 512 /* SvgElement */;
        case Fragment:
            return 4096 /* Fragment */;
        default:
            return 2 /* CommonElement */;
    }
}
function createElementVNode(type, tag, children, childrenType, className, props, key, ref) {
    if (process.env.NODE_ENV !== 'production') {
        if (type & 28 /* Component */) {
            throwError('Creating Component vNodes using createVNode is not allowed. Use createComponentVNode method.');
        }
    }
    if (isNullOrUndefined(childrenType)) {
        childrenType = 1 /* HasInvalidChildren */;
    }
    var vNode = new VNode(type, tag, childrenType, children, className, props, key, ref);
    if (childrenType === 0 /* UnknownChildren */) {
        normalizeChildren(vNode, children);
    }
    if (process.env.NODE_ENV !== 'production') {
        validateVNodeElementChildren(vNode);
    }
    return vNode;
}
function createComponentVNode(type, tag, props, key, ref) {
    if (process.env.NODE_ENV !== 'production') {
        if (type & 962 /* Element */) {
            throwError('Creating element vNodes using createComponentVNode is not allowed. Use createElementVNode method.');
        }
    }
    if ((type & 24 /* ComponentKnown */) === 0) {
        if (tag.prototype && tag.prototype.$render) {
            type = 8 /* ComponentClass */;
        }
        else {
            type = 16 /* ComponentFunction */;
        }
    }
    return new VNode(type, tag, 1 /* HasInvalidChildren */, null, null, props, key, ref);
}
function createUnknownComponentVNode(tag, props, key, ref) {
    // for react forwardRef element, see intact-react 
    var type = tag._$type;
    if (type) {
        tag = type;
    }
    return createComponentVNode(4 /* ComponentUnknown */, tag, props, key, ref);
}
function createTextVNode(text, key) {
    return new VNode(1 /* Text */, null, 1 /* HasInvalidChildren */, text, null, null, key, null);
}
function createVoidVNode() {
    return createTextVNode('', null);
}
function createUnescapeTextVNode(text) {
    return new VNode(1024 /* UnescapeText */, null, 1 /* HasInvalidChildren */, text, null, null, null, null);
}
function createCommentVNode(comment, key) {
    return new VNode(32 /* HtmlComment */, null, 1 /* HasInvalidChildren */, comment, null, null, key, null);
}
function createFragment(children, childrenType, key) {
    var fragment = createElementVNode(4096 /* Fragment */, 4096 /* Fragment */, children, childrenType, null, null, key, null);
    switch (fragment.childrenType) {
        case 1 /* HasInvalidChildren */:
            fragment.children = createVoidVNode();
            fragment.childrenType = 2 /* HasVNodeChildren */;
            break;
        case 16 /* HasTextChildren */:
            fragment.children = [createTextVNode(children)];
            fragment.childrenType = 4 /* HasNonKeyedChildren */;
            break;
    }
    return fragment;
}
function directClone(vNode) {
    var type = vNode.type & -8193 /* ClearInUse */;
    var props = vNode.props;
    // FIXME: need clone props?
    // if (type & Types.Component) {
    // if (!isNullOrUndefined(props)) {
    // const propsToClone = props;
    // props = {};
    // for (const key in propsToClone) {
    // props[key] = propsToClone[key];
    // }
    // }
    // }
    var newVNode;
    if (type & 4096 /* Fragment */) {
        var childrenType = vNode.childrenType;
        newVNode = new VNode(type, vNode.tag, childrenType, childrenType === 2 /* HasVNodeChildren */ ?
            directClone(vNode.children) :
            vNode.children.map(directClone), null, null, vNode.key, null);
    }
    else {
        var children = vNode.children;
        var childrenType = vNode.childrenType;
        newVNode = new VNode(type, vNode.tag, childrenType, 
        // should slice children array, if it is a element,
        // because we will asign new cloned vNode to the array
        // if the child vNode should be cloned
        type & 962 /* Element */ && childrenType & 12 /* MultipleChildren */ ?
            vNode.children.slice() :
            children, vNode.className, props, vNode.key, vNode.ref);
    }
    newVNode.transition = vNode.transition;
    newVNode.hooks = vNode.hooks;
    // newVNode.newPosition = vNode.newPosition;
    // newVNode.position = vNode.position;
    return newVNode;
}
function normalizeChildren(vNode, children) {
    var newChildren;
    var newChildrenType = 1 /* HasInvalidChildren */;
    if (isInvalid(children)) {
        newChildren = children;
    }
    else if (isStringOrNumber(children)) {
        newChildrenType = 16 /* HasTextChildren */;
        newChildren = children;
    }
    else if (isArray(children)) {
        var len = children.length;
        var reference = { index: 0 };
        for (var i = 0; i < len; i++) {
            var n = children[i];
            if (isInvalid(n) || isArray(n)) {
                newChildren = newChildren || children.slice(0, i);
                _normalizeVNodes(children, newChildren, i, reference);
                break;
            }
            else if (isStringOrNumber(n)) {
                newChildren = newChildren || children.slice(0, i);
                newChildren.push(applyKey(createTextVNode(n), reference));
            }
            else {
                if (process.env.NODE_ENV !== 'production') {
                    throwIfObjectIsNotVNode(n);
                }
                var key = n.key;
                var type = n.type;
                var needsCloning = (type & 24576 /* InUseOrNormalized */) > 0;
                var isNullOrUndefinedKey = isNullOrUndefined(key);
                var isPrefixed = (type & 32768 /* PrefixedKey */) > 0;
                if (needsCloning || isNullOrUndefinedKey || isPrefixed) {
                    newChildren = newChildren || children.slice(0, i);
                    if (needsCloning || isPrefixed) {
                        n = directClone(n);
                    }
                    if (isNullOrUndefinedKey || isPrefixed) {
                        applyKey(n, reference);
                    }
                    newChildren.push(n);
                }
                else if (newChildren) {
                    newChildren.push(n);
                }
                n.type |= 16384 /* Normalized */;
            }
            reference.index++;
        }
        newChildren = newChildren || children;
        if (newChildren.length === 0) {
            newChildrenType = 1 /* HasInvalidChildren */;
        }
        else {
            newChildrenType = 8 /* HasKeyedChildren */;
        }
    }
    else {
        if (process.env.NODE_ENV !== 'production') {
            throwIfObjectIsNotVNode(children);
        }
        newChildren = children;
        if (children.type & 24576 /* InUseOrNormalized */) {
            newChildren = directClone(children);
        }
        newChildren.type |= 16384 /* Normalized */;
        newChildrenType = 2 /* HasVNodeChildren */;
    }
    vNode.children = newChildren;
    vNode.childrenType = newChildrenType;
    return vNode;
}
function applyKey(vNode, reference) {
    vNode.key = '$' + reference.index;
    vNode.type |= 32768 /* PrefixedKey */;
    return vNode;
}
function _normalizeVNodes(vNodes, result, index, reference) {
    for (var len = vNodes.length; index < len; index++) {
        var n = vNodes[index];
        if (!isInvalid(n)) {
            if (isArray(n)) {
                _normalizeVNodes(n, result, 0, reference);
                continue;
            }
            else {
                if (isStringOrNumber(n)) {
                    n = applyKey(createTextVNode(n), reference);
                }
                else {
                    if (process.env.NODE_ENV !== 'production') {
                        throwIfObjectIsNotVNode(n);
                    }
                    var type = n.type;
                    var isPrefixed = (type & 32768 /* PrefixedKey */) > 0;
                    if (type & 24576 /* InUseOrNormalized */ || isPrefixed) {
                        n = directClone(n);
                    }
                    n.type |= 16384 /* Normalized */;
                    if (isNullOrUndefined(n.key) || isPrefixed) {
                        applyKey(n, reference);
                    }
                }
                result.push(n);
            }
        }
        reference.index++;
    }
}
function normalizeRoot(vNode, parentVNode) {
    var root;
    if (isInvalid(vNode)) {
        root = createVoidVNode();
    }
    else if (isStringOrNumber(vNode)) {
        root = createTextVNode(vNode, null);
    }
    else if (isArray(vNode)) {
        root = createFragment(vNode, 0 /* UnknownChildren */, null);
    }
    else {
        root = vNode.type & 8192 /* InUse */ ? directClone(vNode) : vNode;
    }
    var transition = parentVNode.transition;
    if (!isNullOrUndefined(transition)) {
        // if it has multipe vNodes, only transition on the first vNode
        // if (process.env.NODE_ENV !== 'production') {
        // const type = root.type;
        // if (!(type & Types.Component || type & Types.Element)) {
        // throwError(`Component inside <Transtion> must render a single elememt node.`);
        // }
        // }
        root.transition = transition;
    }
    var hooks = parentVNode.hooks;
    if (!isNullOrUndefined(hooks)) {
        root.hooks = hooks;
    }
    return root;
}

function linkEvent(data, event) {
    if (isFunction(event)) {
        return { data: data, event: event };
    }
    return null;
}
function isLinkEvent(o) {
    return !isNull(o) && typeof o === 'object';
}
function isSameLinkEvent(lastValue, nextValue) {
    return (isLinkEvent(lastValue) &&
        lastValue.event === nextValue.event &&
        lastValue.data === nextValue.data);
}
function wrapLinkEvent(nextValue) {
    var ev = nextValue.event;
    return function (e) {
        ev(nextValue.data, e);
    };
}

function getDelegatedEventObject(v) {
    return {
        'ev-click': v,
        'ev-dblclick': v,
        'ev-focusin': v,
        'ev-focusout': v,
        'ev-keydown': v,
        'ev-keypress': v,
        'ev-keyup': v,
        'ev-mousedown': v,
        'ev-mousemove': v,
        'ev-mouseup': v,
        'ev-touchend': v,
        'ev-touchmove': v,
        'ev-touchstart': v,
        'ev-contextmenu': v,
    };
}
/**
 * In QianKun framework, the main App and sub App may use misstime simultaneously
 * https://github.com/ksc-fe/kpc/issues/1002
 */
var w = globalThis;
var attachedEventCounts = w.__misstime_attachedEventCounts__ || (w.__misstime_attachedEventCounts__ = /*#__PURE__*/ getDelegatedEventObject(0));
var attachedEvents = w.__misstime_attachedEvents__ || (w.__misstime_attachedEvents__ = /*#__PURE__*/ getDelegatedEventObject(null));
var delegatedEvents = /*#__PURE__*/ getDelegatedEventObject(true);
function updateOrAddDelegatedEvent(name, dom) {
    var eventsObject = dom.$EV;
    if (!eventsObject) {
        eventsObject = dom.$EV = getDelegatedEventObject(null);
    }
    if (!eventsObject[name]) {
        if (++attachedEventCounts[name] === 1) {
            attachedEvents[name] = attachEventToDocument(name);
        }
    }
    return eventsObject;
}
function unmountDelegatedEvent(name, dom) {
    var eventsObject = dom.$EV;
    if (eventsObject && eventsObject[name]) {
        if (--attachedEventCounts[name] === 0) {
            document.removeEventListener(normalizeEventName(name), attachedEvents[name]);
            attachedEvents[name] = null;
        }
        eventsObject[name] = null;
    }
    return eventsObject;
}
function handleDelegatedEvent(name, lastEvent, nextEvent, dom) {
    if (isFunction(nextEvent)) {
        updateOrAddDelegatedEvent(name, dom)[name] = nextEvent;
    }
    else if (isLinkEvent(nextEvent)) {
        if (isSameLinkEvent(lastEvent, nextEvent)) {
            return;
        }
        updateOrAddDelegatedEvent(name, dom)[name] = nextEvent;
    }
    else {
        unmountDelegatedEvent(name, dom);
    }
}
function attachEventToDocument(name) {
    var attachedEvent = // name === 'ev-click' || name === 'ev-dblclick' ?
     
    // rootClickEvent(name) :
    rootEvent(name);
    document.addEventListener(normalizeEventName(name), attachedEvent);
    return attachedEvent;
}
// function rootClickEvent(name: string) {
// return function(event: Event) {
// if ((event as MouseEvent).button !== 0) {
// event.stopPropagation();
// return;
// }
// dispatchEvents(event, true, name, extendEventProperites(event));
// }
// }
function rootEvent(name) {
    var isClick = name === 'ev-click' || name === 'ev-dblclick';
    return function (event) {
        dispatchEvents(event, isClick, name, extendEventProperites(event));
    };
}
function extendEventProperites(event) {
    var eventData = {
        dom: document
    };
    event.stopPropagation = stopPropagation;
    Object.defineProperty(event, 'currentTarget', {
        configurable: true,
        get: function () {
            return eventData.dom;
        }
    });
    return eventData;
}
function stopPropagation() {
    this.cancelBubble = true;
    if (this.stopImmediatePropagation) {
        this.stopImmediatePropagation();
    }
}
function dispatchEvents(event, isClick, name, eventData) {
    var dom = getTargetNode(event);
    var count = attachedEventCounts[name];
    do {
        if (isClick && dom.disabled) {
            return;
        }
        var eventsObject = dom.$EV;
        if (eventsObject) {
            var currentEvent = eventsObject[name];
            if (currentEvent) {
                eventData.dom = dom;
                currentEvent.event ?
                    currentEvent.event(currentEvent.data, event) :
                    currentEvent(event);
                if (--count === 0 || event.cancelBubble) {
                    return;
                }
            }
        }
        dom = dom.parentNode;
    } while (!isNull(dom));
}
function getTargetNode(event) {
    return isFunction(event.composedPath) ?
        event.composedPath()[0] :
        /* istanbul ignore next */
        event.target;
}

function attachEvent(dom, eventName, handler) {
    var previousKey = "$".concat(eventName);
    var previousArgs = dom[previousKey];
    if (previousArgs) {
        dom.removeEventListener(previousArgs[0], previousArgs[1]);
        dom[previousKey] = null;
    }
    if (isFunction(handler)) {
        dom.addEventListener(eventName, handler);
        dom[previousKey] = [eventName, handler];
    }
}
function attachModelEvent(dom, eventName, handler) {
    var previousKey = "$$model:".concat(eventName);
    var previousEvent = dom[previousKey];
    if (previousEvent) {
        dom.removeEventListener(eventName, previousEvent);
        dom[previousKey] = null;
    }
    if (isFunction(handler)) {
        dom.addEventListener(eventName, handler);
        dom[previousKey] = handler;
    }
}

function applyValueInput(nextProps, dom, isControlled) {
    var type = nextProps.type, value = nextProps.value, checked = nextProps.checked, multiple = nextProps.multiple, defaultValue = nextProps.defaultValue;
    var hasValue = true;
    if (isNullOrUndefined(value)) {
        value = '';
        hasValue = false;
    }
    // FIXME: it seems like it need not handle because patchProp will handle it
    // if (type && type !== dom.type) {
    // dom.setAttribute('type', type);
    // }
    if (!isNullOrUndefined(multiple) && multiple !== dom.multiple) {
        dom.multiple = multiple;
    }
    if (!isNullOrUndefined(defaultValue) && !isControlled) {
        dom.defaultValue = defaultValue + '';
    }
    if (isCheckedType(type)) {
        if (isControlled || hasValue) {
            dom.value = value;
        }
        if (!isNullOrUndefined(checked)) {
            dom.checked = checked;
        }
    }
    else {
        if ((isControlled || hasValue) && dom.value !== value) {
            dom.defaultValue = value;
            dom.value = value;
        }
        else if (!isNullOrUndefined(checked)) {
            dom.checked = checked;
        }
    }
}
function isCheckedType(type) {
    return type === 'checkbox' || type === 'radio';
}

// export function selectEvents(dom: HTMLSelectElement, event?: EventListener) {
// attachModelEvent(dom, 'change', event);
// }
function applyValueSelect(nextProps, dom, mounting, vNode, isControlled) {
    var multiple = nextProps.multiple;
    if (!isNullOrUndefined(multiple) && multiple !== dom.multiple) {
        dom.multiple = multiple;
    }
    var index = nextProps.selectedIndex;
    if (index === -1) {
        dom.selectedIndex = -1;
    }
    var childrenType = vNode.childrenType;
    if (childrenType !== 1 /* HasInvalidChildren */) {
        var value = nextProps.value;
        if (isNumber(index) && index > -1 && dom.options[index]) {
            value = dom.options[index].value;
        }
        if (mounting && isNullOrUndefined(value)) {
            value = nextProps.defaultValue;
        }
        if (!isNullOrUndefined(value) || isControlled || multiple) {
            REFERENCE.value = false;
            updateChildOptions(vNode, value, REFERENCE);
            if (!REFERENCE.value) {
                dom.selectedIndex = -1;
            }
        }
    }
}
function updateChildOptions(vNode, value, flag) {
    if (vNode.tag === 'option') {
        updateChildOption(vNode, value, flag);
    }
    else {
        var children = vNode.children;
        var type = vNode.type;
        if (type & 8 /* ComponentClass */) {
            updateChildOptions(children.$lastInput, value, flag);
        }
        else if (type & 16 /* ComponentFunction */) {
            updateChildOptions(children, value, flag);
        }
        else if (vNode.childrenType === 2 /* HasVNodeChildren */) {
            updateChildOptions(children, value, flag);
        }
        else if (vNode.childrenType & 12 /* MultipleChildren */) {
            for (var i = 0, len = children.length; i < len; ++i) {
                updateChildOptions(children[i], value, flag);
            }
        }
    }
}
function updateChildOption(vNode, value, flag) {
    var props = vNode.props || EMPTY_OBJ;
    var dom = vNode.dom;
    // dom.value = props.value;
    if (props.value === value || isArray(value) && value.indexOf(props.value) !== -1) {
        flag.value = true;
        dom.selected = true;
    }
    else if (!isNullOrUndefined(value)) {
        // if exist value ignore the selected prop of option
        dom.selected = false;
    }
    else if (!isNullOrUndefined(props.selected)) {
        var selected = props.selected || false;
        if (selected)
            flag.value = true;
        dom.selected = selected;
    }
}

// export function textareaEvents(dom: HTMLTextAreaElement, event?: EventListener) {
// attachModelEvent(dom, 'input', event);
// }
function applyValueTextArea(nextProps, dom, mounting, isControlled) {
    var value = nextProps.value;
    var domValue = dom.value;
    if (!isControlled) {
        if (mounting) {
            var defaultValue = nextProps.defaultValue;
            if (!isNullOrUndefined(defaultValue) && defaultValue !== domValue) {
                dom.value = dom.defaultValue = defaultValue;
            }
        }
    }
    else if (domValue !== value) {
        dom.value = dom.defaultValue = isNullOrUndefined(value) ? '' : value;
    }
}

function processElement(type, vNode, dom, nextProps, mounting, isControlled) {
    if (type & 64 /* InputElement */) {
        applyValueInput(nextProps, dom, isControlled);
    }
    else if (type & 128 /* SelectElement */) {
        applyValueSelect(nextProps, dom, mounting, vNode, isControlled);
    }
    else if (type & 256 /* TextareaElement */) {
        applyValueTextArea(nextProps, dom, mounting, isControlled);
    }
}

function isRef(o) {
    return o.__is_ref;
}
function createRef(defaultValue) {
    return {
        value: isUndefined(defaultValue) ? null : defaultValue,
        __is_ref: true,
    };
}
/**
 * We must mount ref after all operations completed, because when we patch children,
 * one child will be mounted before being removed. e.g.
 * patchTest(
 *     h('div', null, [h('div'), h('div', {ref})]),
 *     h('div', null, [h('div', {ref})]),
 * );
 */
function mountRef(ref, value, mountedQueue) {
    if (ref) {
        /**
         * We mount ref before doing anything else, so that we can obtain the correct ref anywhere.
         *
         * In some cases, we will mount ref when framework is calling mountedQueue. So we must add
         * a index flag to indicate which position to insert the ref callback.
         */
        mountedQueue.splice(mountedQueue.i || 0, 0, function () {
            if (isFunction(ref)) {
                ref(value);
            }
            else if (isRef(ref)) {
                ref.value = value;
            }
        });
    }
}
function unmountRef(ref) {
    if (ref) {
        if (isFunction(ref)) {
            ref(null);
        }
        else if (isRef(ref)) {
            ref.value = null;
        }
    }
}

function remove(vNode, parentDom, reusing) {
    if (!reusing) {
        unmount(vNode, null);
    }
    removeVNodeDom(vNode, parentDom);
}
function unmount(vNode, nextVNode) {
    var type = vNode.type;
    var children = vNode.children;
    if (type & 962 /* Element */) {
        var props = vNode.props;
        unmountRef(vNode.ref);
        var childrenType = vNode.childrenType;
        if (!isNullOrUndefined(props)) {
            for (var prop in props) {
                if (delegatedEvents[prop]) {
                    unmountDelegatedEvent(prop, vNode.dom);
                }
            }
        }
        if (childrenType & 12 /* MultipleChildren */) {
            unmountAllChildren(children);
        }
        else if (childrenType === 2 /* HasVNodeChildren */) {
            unmount(children, null);
        }
    }
    else if (children) {
        if (type & 8 /* ComponentClass */) {
            unmountComponentClass(vNode, nextVNode);
        }
        else if (type & 16 /* ComponentFunction */) {
            unmount(children, null);
        }
        else if (type & 4096 /* Fragment */) {
            if (vNode.childrenType & 12 /* MultipleChildren */) {
                unmountAllChildren(children);
            }
        }
    }
}
function unmountComponentClass(vNode, nextVNode) {
    vNode.children.$unmount(vNode, nextVNode);
    unmountRef(vNode.ref);
}
function unmountAllChildren(children) {
    for (var i = 0, len = children.length; i < len; ++i) {
        unmount(children[i], null);
    }
}
function clearDom(dom) {
    dom.textContent = '';
}
function removeAllChildren(children, dom, vNode, reusing) {
    if (!reusing) {
        unmountAllChildren(children);
    }
    if (vNode.type & 4096 /* Fragment */) {
        removeVNodeDom(vNode, dom);
    }
    else {
        for (var i = 0; i < children.length; i++) {
            removeVNodeDom(children[i], dom);
        }
        // clearDom(dom);
    }
}

function mountProps(vNode, type, props, dom, isSVG) {
    var isFormElement = (type & 448 /* FormElement */) > 0;
    REFERENCE.value = false;
    for (var prop in props) {
        patchProp(prop, null, props[prop], dom, isSVG, isFormElement, REFERENCE, null);
    }
    if (isFormElement) {
        processElement(type, vNode, dom, props, true, REFERENCE.value);
    }
}
function patchProp(prop, lastValue, nextValue, dom, isSVG, isFormElement, hasControlledValue, lastVNode) {
    var value;
    switch (prop) {
        case 'children':
        case 'className':
        case 'defaultValue':
        case 'key':
        case 'ref':
        case 'multiple':
        case 'selectedIndex':
        case '$blocks':
            break;
        // case 'autoFocus':
        // (dom as any).autofocus = !!nextValue;
        // break;
        case 'autofocus':
        case 'allowfullscreen':
        case 'autoplay':
        case 'capture':
        case 'checked':
        case 'controls':
        case 'default':
        case 'disabled':
        case 'hidden':
        case 'indeterminate':
        case 'loop':
        case 'muted':
        case 'novalidte':
        case 'open':
        case 'readOnly':
        case 'required':
        case 'reversed':
        case 'scoped':
        case 'seamless':
        case 'selected':
        case 'spellcheck':
            dom[prop] = !!nextValue;
            break;
        // special bool value
        case 'formnovalidate':
            dom.formNoValidate = !!nextValue;
            break;
        case 'defaultChecked':
        case 'value':
        case 'volume':
            // if (hasControlledValue && prop === 'value') break;
            if (prop === 'value') {
                dom.$VA = nextValue;
                if (isFormElement) {
                    hasControlledValue.value = true;
                    break;
                }
            }
            value = isNullOrUndefined(nextValue) ? '' : nextValue;
            if (dom[prop] !== value) {
                dom[prop] = value;
            }
            break;
        // TODO: scrollLeft/scrollTop must be handled after style and mounted (use mountedQueue)
        case 'scrollLeft':
        case 'scrollTop':
            value = isNullOrUndefined(nextValue) ? 0 : nextValue;
            if (dom[prop] !== value) {
                dom[prop] = value;
            }
            break;
        case 'innerHTML':
            patchInnerHTML(lastValue, nextValue, dom, lastVNode);
            break;
        case 'style':
            patchStyle(lastValue, nextValue, dom);
            break;
        // handle v-model
        case '$model:value':
            dom.$M = nextValue;
            break;
        case 'trueValue':
            dom.$TV = nextValue;
            break;
        case 'falseValue':
            dom.$FV = nextValue;
            break;
        case 'ev-$model:change':
            patchModelEvent('change', lastValue, nextValue, dom);
            break;
        case 'ev-$model:input':
            patchModelEvent('input', lastValue, nextValue, dom);
            break;
        default:
            if (delegatedEvents[prop]) {
                handleDelegatedEvent(prop, lastValue, nextValue, dom);
            }
            else if (isEventProp(prop)) {
                patchEvent(prop, lastValue, nextValue, dom);
            }
            else if (isNullOrUndefined(nextValue)) {
                dom.removeAttribute(prop);
            }
            else if (isSVG && namespaces[prop]) {
                dom.setAttributeNS(namespaces[prop], prop, nextValue);
            }
            else {
                dom.setAttribute(prop, nextValue);
            }
            break;
    }
}
function patchStyle(lastValue, nextValue, dom) {
    if (isNullOrUndefined(nextValue)) {
        dom.removeAttribute('style');
    }
    else {
        // In most cases, we need not read dom.style
        // const domStyle = (dom as HTMLElement).style as any;
        if (isString(nextValue)) {
            dom.style.cssText = nextValue;
        }
        else {
            var style = void 0;
            var value = void 0;
            var domStyle = void 0;
            var hasLastValue = !isNullOrUndefined(lastValue);
            if (hasLastValue && !isString(lastValue)) {
                for (style in nextValue) {
                    value = nextValue[style];
                    if (value !== lastValue[style]) {
                        (domStyle || (domStyle = dom.style))[style] = value;
                    }
                }
                for (style in lastValue) {
                    if (isNullOrUndefined(nextValue[style])) {
                        (domStyle || (domStyle = dom.style))[style] = '';
                    }
                }
            }
            else {
                if (hasLastValue) {
                    // remove style firstly if lastValue is string
                    dom.removeAttribute('style');
                }
                for (style in nextValue) {
                    value = nextValue[style];
                    (domStyle || (domStyle = dom.style))[style] = value;
                }
            }
        }
    }
    // handle Transition display
    var display = dom.$TD;
    if (!isUndefined(display)) {
        dom.style.display = display;
    }
}
function patchEvent(name, lastValue, nextValue, dom) {
    if (isLinkEvent(nextValue)) {
        if (isSameLinkEvent(lastValue, nextValue)) {
            return;
        }
        nextValue = wrapLinkEvent(nextValue);
    }
    attachEvent(dom, normalizeEventName(name), nextValue);
}
function patchModelEvent(name, lastValue, nextValue, dom) {
    if (isLinkEvent(nextValue)) {
        if (isSameLinkEvent(lastValue, nextValue)) {
            return;
        }
        nextValue = wrapLinkEvent(nextValue);
    }
    attachModelEvent(dom, name, nextValue);
}
function patchInnerHTML(lastValue, nextValue, dom, lastVNode) {
    if (isNullOrUndefined(lastValue)) {
        lastValue = '';
    }
    if (isNullOrUndefined(nextValue)) {
        nextValue = '';
    }
    if (lastValue !== nextValue) {
        if (!isNull(lastVNode)) {
            if (lastVNode.childrenType & 12 /* MultipleChildren */) {
                unmountAllChildren(lastVNode.children);
            }
            else if (lastVNode.childrenType === 2 /* HasVNodeChildren */) {
                unmount(lastVNode.children, null);
            }
            lastVNode.children = null;
            lastVNode.childrenType = 1 /* HasInvalidChildren */;
        }
        dom.innerHTML = nextValue;
    }
}

function mount(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue) {
    var type = (vNode.type |= 8192 /* InUse */);
    if (type & 962 /* Element */) {
        mountElement(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else if (type & 8 /* ComponentClass */) {
        mountComponentClass(null, vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else if (type & 16 /* ComponentFunction */) {
        mountComponentFunction(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else if (type & 1 /* Text */ /*  || type & Types.Void */) {
        mountText(vNode, parentDom, anchor);
    }
    else if (type & 4096 /* Fragment */) {
        mountFragment(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else if (type & 32 /* HtmlComment */) {
        mountComment(vNode, parentDom, anchor);
    }
    else if (process.env.NODE_ENV !== 'production') {
        if (typeof vNode === 'object') {
            throwError("mount() received an object that's not a valid VNode, you should stringify it first, " +
                "fix createVNode type or call normalizeChildren. Object: \"".concat(JSON.stringify(vNode), "\"."));
        }
        else {
            throwError("mount() expects a valid VNode, instead it received an object with the type \"".concat(typeof vNode, "\"."));
        }
    }
}
function mountElement(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue) {
    var type = vNode.type, props = vNode.props, className = vNode.className, childrenType = vNode.childrenType, tag = vNode.tag, transition = vNode.transition, hooks = vNode.hooks;
    isSVG = isSVG || (type & 512 /* SvgElement */) > 0;
    var dom = vNode.dom = documentCreateElement(tag, isSVG);
    if (!isNullOrUndefined(className) && className !== '') {
        if (isSVG) {
            dom.setAttribute('class', className);
        }
        else {
            dom.className = className;
        }
    }
    if (process.env.NODE_ENV !== 'production') {
        validateKeys(vNode);
    }
    var children = vNode.children;
    // We should mount Ref firstly, because we may get parent ref in children component
    // in $render method, e.g. Portal of KPC
    // mountRef(vNode.ref, dom);
    // @MODIFY: we have to mount ref in mountedQueue
    if (childrenType === 16 /* HasTextChildren */) {
        setTextContent(dom, children);
    }
    else if (childrenType !== 1 /* HasInvalidChildren */) {
        var childrenIsSVG = isSVG && tag !== 'foreignObject';
        if (childrenType === 2 /* HasVNodeChildren */) {
            if (children.type & 8192 /* InUse */) {
                vNode.children = children = directClone(children);
            }
            mount(children, dom, parentComponent, childrenIsSVG, null, mountedQueue);
        }
        else if (childrenType === 8 /* HasKeyedChildren */ ||
            childrenType === 4 /* HasNonKeyedChildren */) {
            mountArrayChildren(children, vNode, dom, parentComponent, childrenIsSVG, null, mountedQueue);
        }
    }
    if (!isNullOrUndefined(hooks)) {
        var beforeInsert = hooks.beforeInsert;
        if (!isNullOrUndefined(beforeInsert)) {
            beforeInsert(vNode, parentComponent);
        }
    }
    if (!isNullOrUndefined(parentDom)) {
        insertOrAppend(parentDom, dom, anchor);
    }
    if (!isNullOrUndefined(props)) {
        mountProps(vNode, type, props, dom, isSVG);
    }
    if (!isNullOrUndefined(transition) && transition.show) {
        transition.beforeEnter(dom);
        mountedQueue.push(function () { return transition.enter(dom); });
    }
    mountRef(vNode.ref, dom, mountedQueue);
}
function mountComponentClass(lastVNode, vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue) {
    if (process.env.NODE_ENV !== 'production') {
        validateProps(vNode);
    }
    var props = vNode.props;
    var instance = new vNode.tag(props, vNode, isSVG, mountedQueue, parentComponent);
    // instance.$SVG = isSVG;
    // instance.$vNode = vNode;
    // instance.$mountedQueue = mountedQueue;
    // instance.$senior = parentComponent;
    instance.$init(props);
    vNode.children = instance;
    instance.$render(lastVNode, vNode, parentDom, anchor, mountedQueue);
    mountRef(vNode.ref, instance, mountedQueue);
    // mountedQueue.push(() => instance.$mount(lastVNode, vNode))
}
function mountComponentFunction(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue) {
    if (process.env.NODE_ENV !== 'production') {
        validateProps(vNode);
    }
    mount((vNode.children = normalizeRoot(vNode.tag(vNode.props || EMPTY_OBJ), vNode)), parentDom, parentComponent, isSVG, anchor, mountedQueue);
}
function mountText(vNode, parentDom, anchor) {
    var dom = vNode.dom = document.createTextNode(vNode.children);
    if (!isNullOrUndefined(parentDom)) {
        insertOrAppend(parentDom, dom, anchor);
    }
}
function mountFragment(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue) {
    // let children = vNode.children;
    // let childrenType = vNode.childrenType;
    // if (childrenType & ChildrenTypes.MultipleChildren && (children as VNode[]).length === 0) {
    // childrenType = vNode.childrenType = ChildrenTypes.HasVNodeChildren;
    // children = vNode.children = createVNode();
    // }
    if (vNode.childrenType === 2 /* HasVNodeChildren */) {
        mount(vNode.children, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else {
        mountArrayChildren(vNode.children, vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
}
function mountComment(vNode, parentDom, anchor) {
    var dom = vNode.dom = document.createComment(vNode.children);
    if (!isNullOrUndefined(parentDom)) {
        insertOrAppend(parentDom, dom, anchor);
    }
}
function mountArrayChildren(children, parentVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue) {
    for (var i = 0; i < children.length; i++) {
        var vNode = children[i];
        if (vNode.type & 8192 /* InUse */) {
            // if (!cloned) {
            // parentVNode.children = children = children.slice();
            // cloned = true;
            // }
            children[i] = vNode = directClone(vNode);
        }
        mount(vNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
}
function documentCreateElement(tag, isSVG) {
    if (isSVG) {
        return document.createElementNS("http://www.w3.org/2000/svg", tag);
    }
    return document.createElement(tag);
}
// export function createComponentClassInstance(
// lastVNode: VNodeComponentClass | null,
// vNode: VNodeComponentClass,
// Component: ComponentConstructor,
// props: Props,
// isSVG: boolean,
// mountedQueue: Function[],
// ) {
// }

function patch(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing) {
    var nextType = (nextVNode.type |= 8192 /* InUse */);
    if (lastVNode.type !== nextType || lastVNode.key !== nextVNode.key) {
        replaceWithNewNode(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
    }
    else if (nextType & 8 /* ComponentClass */) {
        // if patch two class components, reuse its dom otherwise replace the dom totally.
        patchComponentClass(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
    }
    else if (lastVNode.tag !== nextVNode.tag) {
        replaceWithNewNode(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
    }
    else if (nextType & 962 /* Element */) {
        patchElement(lastVNode, nextVNode, parentComponent, isSVG, nextType, mountedQueue, reusing);
    }
    else if (nextType & 16 /* ComponentFunction */) {
        patchComponentFunction(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
    }
    else if (nextType & 1 /* Text */ || nextType & 32 /* HtmlComment */) {
        patchText(lastVNode, nextVNode);
    }
    else if (nextType & 4096 /* Fragment */) {
        patchFragment(lastVNode, nextVNode, parentDom, parentComponent, isSVG, mountedQueue, reusing);
    }
}
function replaceWithNewNode(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing) {
    if (lastVNode.type & 8192 /* InUse */) {
        if (!reusing) {
            unmount(lastVNode, null);
        }
        if ((nextVNode.type & lastVNode.type & 3043 /* HtmlElement */) && isUndefined(lastVNode.transition)) {
            // single dom
            mount(nextVNode, null, parentComponent, isSVG, null, mountedQueue);
            replaceChild(parentDom, nextVNode.dom, lastVNode.dom);
        }
        else {
            mount(nextVNode, parentDom, parentComponent, isSVG, 
            // we must insert the dom after the old dom, because it may has Transition
            // Inserting it after the old one to make the old dom's position don't change
            findDomFromVNode(lastVNode, true).nextSibling, mountedQueue);
            removeVNodeDom(lastVNode, parentDom);
        }
    }
    else {
        // Last vNode is not in use, it has crashed. Just mount next vNode and ignore last one.
        mount(nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
}
function patchComponentClass(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing) {
    var nextTag = nextVNode.tag;
    if (lastVNode.tag !== nextTag || reusing) {
        if (!reusing) {
            unmount(lastVNode, nextVNode);
        }
        mountComponentClass(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else {
        if (process.env.NODE_ENV !== 'production') {
            validateProps(nextVNode);
        }
        var instance = nextVNode.children = lastVNode.children;
        // If component has crashed, ignore it to stay functional
        /* istanbul ignore next */
        if (isNullOrUndefined(instance))
            return;
        instance.$mountedQueue = mountedQueue;
        instance.$vNode = nextVNode;
        instance.$senior = parentComponent;
        instance.$update(lastVNode, nextVNode, parentDom, anchor, mountedQueue, false);
        var lastRef = lastVNode.ref;
        var nextRef = nextVNode.ref;
        if (lastRef !== nextRef) {
            unmountRef(lastRef);
            mountRef(nextRef, instance, mountedQueue);
        }
    }
}
function patchComponentFunction(lastVNode, nextVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing) {
    if (process.env.NODE_ENV !== 'production') {
        validateProps(nextVNode);
    }
    var nextChildren = normalizeRoot(nextVNode.tag(nextVNode.props || EMPTY_OBJ), nextVNode);
    patch(lastVNode.children, nextChildren, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
    nextVNode.children = nextChildren;
}
function patchElement(lastVNode, nextVNode, parentComponent, isSVG, nextType, mountedQueue, reusing) {
    var dom = nextVNode.dom = lastVNode.dom;
    var lastProps = lastVNode.props || EMPTY_OBJ;
    var nextProps = nextVNode.props || EMPTY_OBJ;
    isSVG = isSVG || (nextType & 512 /* SvgElement */) > 0;
    REFERENCE.value = false;
    var isFormElement = false;
    if (lastProps !== nextProps) {
        if (nextProps !== EMPTY_OBJ) {
            isFormElement = (nextType & 448 /* FormElement */) > 0;
            for (var prop in nextProps) {
                // maybe the lastProps is the same as nextProps, we can't go to patchProp
                if (prop === 'value')
                    REFERENCE.value = true;
                var lastValue = lastProps[prop];
                var nextValue = nextProps[prop];
                if (lastValue !== nextValue) {
                    patchProp(prop, lastValue, nextValue, dom, isSVG, isFormElement, REFERENCE, lastVNode);
                }
            }
        }
        if (lastProps !== EMPTY_OBJ) {
            for (var prop in lastProps) {
                if (isNullOrUndefined(nextProps[prop]) && !isNullOrUndefined(lastProps[prop])) {
                    patchProp(prop, lastProps[prop], null, dom, isSVG, isFormElement, REFERENCE, lastVNode);
                }
            }
        }
    }
    // patch className
    var nextClassName = nextVNode.className;
    if (lastVNode.className !== nextClassName) {
        var transitionClassname = dom.$TC;
        if (isNullOrUndefined(nextClassName)) {
            if (isUndefined(transitionClassname)) {
                dom.removeAttribute('class');
            }
            else {
                dom.className = Object.keys(transitionClassname).join(' ');
            }
        }
        else if (isSVG) {
            dom.setAttribute('class', nextClassName);
        }
        else if (isUndefined(transitionClassname)) {
            dom.className = nextClassName;
        }
        else {
            dom.className = nextClassName + ' ' + Object.keys(transitionClassname).join(' ');
        }
    }
    if (process.env.NODE_ENV !== 'production') {
        validateKeys(nextVNode);
    }
    var nextChildren = nextVNode.children;
    var nextChildrenType = nextVNode.childrenType;
    if (nextChildrenType === 2 /* HasVNodeChildren */) {
        if (nextChildren.type & 8192 /* InUse */) {
            nextVNode.children = nextChildren = directClone(nextChildren);
        }
    }
    // TODO: patchContendEditableChild
    // if (nextType & )
    patchChildren(lastVNode.childrenType, nextChildrenType, lastVNode.children, nextChildren, dom, parentComponent, isSVG && nextVNode.tag !== 'foreignObject', null, lastVNode, mountedQueue, reusing);
    if (isFormElement) {
        processElement(nextType, nextVNode, dom, nextProps, false, REFERENCE.value);
    }
    var nextRef = nextVNode.ref;
    if (reusing) {
        mountRef(nextRef, dom, mountedQueue);
    }
    else {
        var lastRef = lastVNode.ref;
        if (lastRef !== nextRef) {
            unmountRef(lastRef);
            mountRef(nextRef, dom, mountedQueue);
        }
    }
}
function patchText(lastVNode, nextVNode) {
    var nextText = nextVNode.children;
    var dom = nextVNode.dom = lastVNode.dom;
    if (nextText !== lastVNode.children) {
        dom.nodeValue = nextText;
    }
}
function patchFragment(lastVNode, nextVNode, parentDom, parentComponent, isSVG, mountedQueue, reusing) {
    var lastChildren = lastVNode.children;
    var nextChildren = nextVNode.children;
    var lastChildrenType = lastVNode.childrenType;
    var nextChildrenType = nextVNode.childrenType;
    var anchor = null;
    // if (nextChildrenType & ChildrenTypes.MultipleChildren && (nextChildren as VNode[]).length === 0) {
    // nextChildrenType = nextVNode.childrenType = ChildrenTypes.HasVNodeChildren;
    // nextChildren = nextVNode.children = createVoidVNode();
    // }
    var nextIsSingle = (nextChildrenType & 2 /* HasVNodeChildren */) !== 0;
    if (lastChildrenType & 12 /* MultipleChildren */) {
        var lastLen = lastChildren.length;
        // We need to known Fragment's edge node when
        if (
        // It uses keyed algorithm
        (lastChildrenType & nextChildrenType & 8 /* HasKeyedChildren */) ||
            // It transforms from may to signle
            nextIsSingle ||
            // It will append more nodes
            nextChildren.length > lastLen) {
            // When Fragment has mutliple children there is always at least one vNode
            anchor = findDomFromVNode(lastChildren[lastLen - 1], false).nextSibling;
        }
    }
    patchChildren(lastChildrenType, nextChildrenType, lastChildren, nextChildren, parentDom, parentComponent, isSVG, anchor, lastVNode, mountedQueue, reusing);
}
function patchChildren(lastChildrenType, nextChildrenType, lastChildren, nextChildren, parentDom, parentComponent, isSVG, anchor, parentVNode, mountedQueue, reusing) {
    switch (lastChildrenType) {
        case 2 /* HasVNodeChildren */:
            switch (nextChildrenType) {
                case 2 /* HasVNodeChildren */:
                    patch(lastChildren, nextChildren, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
                    break;
                case 1 /* HasInvalidChildren */:
                    remove(lastChildren, parentDom, reusing);
                    break;
                case 16 /* HasTextChildren */:
                    if (!reusing) {
                        unmount(lastChildren, null);
                    }
                    setTextContent(parentDom, nextChildren);
                    break;
                default:
                    replaceOneVNodeWithMulipleVNodes(lastChildren, nextChildren, parentVNode, parentDom, parentComponent, isSVG, mountedQueue, reusing);
                    break;
            }
            break;
        case 1 /* HasInvalidChildren */:
            switch (nextChildrenType) {
                case 2 /* HasVNodeChildren */:
                    mount(nextChildren, parentDom, parentComponent, isSVG, anchor, mountedQueue);
                    break;
                case 1 /* HasInvalidChildren */:
                    break;
                case 16 /* HasTextChildren */:
                    setTextContent(parentDom, nextChildren);
                    break;
                default:
                    mountArrayChildren(nextChildren, parentVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
                    break;
            }
            break;
        case 16 /* HasTextChildren */:
            switch (nextChildrenType) {
                case 2 /* HasVNodeChildren */:
                    clearDom(parentDom);
                    mount(nextChildren, parentDom, parentComponent, isSVG, anchor, mountedQueue);
                    break;
                case 1 /* HasInvalidChildren */:
                    clearDom(parentDom);
                    break;
                case 16 /* HasTextChildren */:
                    patchSingleTextChild(lastChildren, nextChildren, parentDom);
                    break;
                default:
                    clearDom(parentDom);
                    mountArrayChildren(nextChildren, parentVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
                    break;
            }
            break;
        default:
            switch (nextChildrenType) {
                case 2 /* HasVNodeChildren */:
                    removeAllChildren(lastChildren, parentDom, parentVNode, reusing);
                    mount(nextChildren, parentDom, parentComponent, isSVG, anchor, mountedQueue);
                    break;
                case 1 /* HasInvalidChildren */:
                    removeAllChildren(lastChildren, parentDom, parentVNode, reusing);
                    break;
                case 16 /* HasTextChildren */:
                    removeAllChildren(lastChildren, parentDom, parentVNode, reusing);
                    setTextContent(parentDom, nextChildren);
                    break;
                default:
                    var lastLength = lastChildren.length;
                    var nextLength = nextChildren.length;
                    if (lastLength === 0) {
                        if (nextLength > 0) {
                            mountArrayChildren(nextChildren, parentVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
                        }
                    }
                    else if (nextLength === 0) {
                        removeAllChildren(lastChildren, parentDom, parentVNode, reusing);
                    }
                    else if (nextChildrenType === 8 /* HasKeyedChildren */ &&
                        lastChildrenType === 8 /* HasKeyedChildren */) {
                        patchKeyedChildren(lastChildren, nextChildren, parentDom, parentComponent, isSVG, lastLength, nextLength, anchor, parentVNode, mountedQueue, reusing);
                    }
                    else {
                        patchNonKeyedChildren(lastChildren, nextChildren, parentDom, parentComponent, isSVG, lastLength, nextLength, anchor, mountedQueue, reusing);
                    }
                    break;
            }
            break;
    }
}
function replaceOneVNodeWithMulipleVNodes(lastVNode, nextVNodes, parentVNode, parentDom, parentComponent, isSVG, mountedQueue, reusing) {
    if (!reusing) {
        unmount(lastVNode, null);
    }
    mountArrayChildren(nextVNodes, parentVNode, parentDom, parentComponent, isSVG, findDomFromVNode(lastVNode, true), mountedQueue);
    removeVNodeDom(lastVNode, parentDom);
}
function patchSingleTextChild(lastChildren, nextChildren, parentDom) {
    if (lastChildren !== nextChildren) {
        if (lastChildren !== '') {
            parentDom.firstChild.nodeValue = nextChildren;
        }
        else {
            setTextContent(parentDom, nextChildren);
        }
    }
}
function patchNonKeyedChildren(lastChildren, nextChildren, parentDom, parentComponent, isSVG, lastChildrenLength, nextChildrenLength, anchor, mountedQueue, reusing) {
    var commonLength = lastChildrenLength > nextChildrenLength ? nextChildrenLength : lastChildrenLength;
    var i = 0;
    var nextChild;
    var lastChild;
    for (; i < commonLength; ++i) {
        nextChild = nextChildren[i];
        lastChild = lastChildren[i];
        if (nextChild.type & 8192 /* InUse */) {
            nextChild = nextChildren[i] = directClone(nextChild);
        }
        patch(lastChild, nextChild, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
        // FIXME: why should update last children?
        // lastChildren[i] = nextChild;
    }
    if (lastChildrenLength < nextChildrenLength) {
        for (i = commonLength; i < nextChildrenLength; ++i) {
            nextChild = nextChildren[i];
            if (nextChild.type & 8192 /* InUse */) {
                nextChild = nextChildren[i] = directClone(nextChild);
            }
            mount(nextChild, parentDom, parentComponent, isSVG, anchor, mountedQueue);
        }
    }
    else if (lastChildrenLength > nextChildrenLength) {
        for (i = commonLength; i < lastChildrenLength; ++i) {
            remove(lastChildren[i], parentDom, reusing);
        }
    }
}
// https://github.com/localvoid/ivi/blob/e23c8572c9ef434c9ac1433e70eff17a88cb8362/packages/ivi/src/vdom/reconciler.ts#L585
// https://yanni4night.github.io/js/2018/02/11/inferno-dom-diff.html
function patchKeyedChildren(a, b, parentDom, parentComponent, isSVG, aLength, bLength, anchor, parentVNode, mountedQueue, reusing) {
    var aEnd = aLength - 1;
    var bEnd = bLength - 1;
    var j = 0;
    var aNode = a[j];
    var bNode = b[j];
    var nextPos;
    var nextNode;
    // Step 1
    outer: {
        // Sync nodes with the same key at the beginning.
        while (aNode.key === bNode.key) {
            if (bNode.type & 8192 /* InUse */) {
                b[j] = bNode = directClone(bNode);
            }
            patch(aNode, bNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
            // a[j] = bNode;
            ++j;
            if (j > aEnd || j > bEnd) {
                break outer;
            }
            aNode = a[j];
            bNode = b[j];
        }
        aNode = a[aEnd];
        bNode = b[bEnd];
        // Sync nodes with the same key at the end.
        while (aNode.key === bNode.key) {
            if (bNode.type & 8192 /* InUse */) {
                b[bEnd] = bNode = directClone(bNode);
            }
            patch(aNode, bNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
            // a[aEnd] = bNode;
            --aEnd;
            --bEnd;
            if (j > aEnd || j > bEnd) {
                break outer;
            }
            aNode = a[aEnd];
            bNode = b[bEnd];
        }
    }
    if (j > aEnd) {
        if (j <= bEnd) {
            nextPos = bEnd + 1;
            nextNode = nextPos < bLength ? findDomFromVNode(b[nextPos], true) : anchor;
            while (j <= bEnd) {
                bNode = b[j];
                if (bNode.type & 8192 /* InUse */) {
                    b[j] = bNode = directClone(bNode);
                }
                ++j;
                mount(bNode, parentDom, parentComponent, isSVG, nextNode, mountedQueue);
            }
        }
    }
    else if (j > bEnd) {
        while (j <= aEnd) {
            remove(a[j++], parentDom, reusing);
        }
    }
    else {
        patchKeyedChildrenComplex(a, b, aLength, bLength, aEnd, bEnd, j, parentDom, parentComponent, isSVG, anchor, parentVNode, mountedQueue, reusing);
    }
}
function patchKeyedChildrenComplex(a, b, aLength, bLength, aEnd, bEnd, j, parentDom, parentComponent, isSVG, anchor, parentVNode, mountedQueue, reusing) {
    var aNode;
    var bNode;
    var nextPos;
    var i = 0;
    var aStart = j;
    var bStart = j;
    var aLeft = aEnd - j + 1;
    var bLeft = bEnd - j + 1;
    var sources = new Int32Array(bLeft + 1);
    // Keep track if it's possible to remove whole DOM using textContent = '';
    var canRemoveWholeContent = aLeft === aLength;
    var moved = false;
    var pos = 0;
    var patched = 0;
    // When sizes are small, just loop them through
    if (bLength < 4 || (aLeft | bLeft) < 32) {
        for (i = aStart; i <= aEnd; ++i) {
            aNode = a[i];
            if (patched < bLeft) {
                for (j = bStart; j <= bEnd; ++j) {
                    bNode = b[j];
                    if (aNode.key === bNode.key) {
                        sources[j - bStart] = i + 1;
                        if (canRemoveWholeContent) {
                            canRemoveWholeContent = false;
                            // remove nodes before the key
                            while (aStart < i) {
                                remove(a[aStart++], parentDom, reusing);
                            }
                        }
                        if (pos > j) {
                            moved = true;
                        }
                        else {
                            pos = j;
                        }
                        if (bNode.type & 8192 /* InUse */) {
                            b[j] = bNode = directClone(bNode);
                        }
                        patch(aNode, bNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
                        ++patched;
                        break;
                    }
                }
                // remove node if it does not find
                if (!canRemoveWholeContent && j > bEnd) {
                    remove(aNode, parentDom, reusing);
                }
            }
            else if (!canRemoveWholeContent) {
                // remove node that exceeds the length
                remove(aNode, parentDom, reusing);
            }
        }
    }
    else {
        var keyIndex = {};
        // Map keys by their index
        for (i = bStart; i <= bEnd; ++i) {
            keyIndex[b[i].key] = i;
        }
        // Try to patch same keys
        for (i = aStart; i <= aEnd; ++i) {
            aNode = a[i];
            if (patched < bLeft) {
                j = keyIndex[aNode.key];
                if (j !== undefined) {
                    if (canRemoveWholeContent) {
                        canRemoveWholeContent = false;
                        while (aStart < i) {
                            remove(a[aStart++], parentDom, reusing);
                        }
                    }
                    sources[j - bStart] = i + 1;
                    if (pos > j) {
                        moved = true;
                    }
                    else {
                        pos = j;
                    }
                    bNode = b[j];
                    if (bNode.type & 8192 /* InUse */) {
                        b[j] = bNode = directClone(bNode);
                    }
                    patch(aNode, bNode, parentDom, parentComponent, isSVG, anchor, mountedQueue, reusing);
                    ++patched;
                }
                else if (!canRemoveWholeContent) {
                    remove(aNode, parentDom, reusing);
                }
            }
            else if (!canRemoveWholeContent) {
                remove(aNode, parentDom, reusing);
            }
        }
    }
    // fast-path: if nothing patched remove all old and add all new
    if (canRemoveWholeContent) {
        removeAllChildren(a, parentDom, parentVNode, reusing);
        mountArrayChildren(b, parentVNode, parentDom, parentComponent, isSVG, anchor, mountedQueue);
    }
    else if (moved) {
        var seq = lisAlgorithm(sources);
        j = seq.length - 1;
        for (i = bLeft - 1; i >= 0; i--) {
            if (sources[i] === 0) {
                pos = i + bStart;
                bNode = b[pos];
                if (bNode.type & 8192 /* InUse */) {
                    b[pos] = bNode = directClone(bNode);
                }
                nextPos = pos + 1;
                mount(bNode, parentDom, parentComponent, isSVG, nextPos < bLength ? findDomFromVNode(b[nextPos], true) : anchor, mountedQueue);
            }
            else if (j < 0 || i !== seq[j]) {
                pos = i + bStart;
                bNode = b[pos];
                nextPos = pos + 1;
                moveVNodeDom(bNode, parentDom, nextPos < bLength ? findDomFromVNode(b[nextPos], true) : anchor);
            }
            else {
                --j;
            }
        }
    }
    else if (patched !== bLeft) {
        // when patched count doesn't match b length we need to insert those new ones
        // loop backwards so we can use insertBefore
        for (i = bLeft - 1; i >= 0; --i) {
            if (sources[i] === 0) {
                pos = i + bStart;
                bNode = b[pos];
                if (bNode.type & 8192 /* InUse */) {
                    b[pos] = bNode = directClone(bNode);
                }
                nextPos = pos + 1;
                mount(bNode, parentDom, parentComponent, isSVG, nextPos < bLength ? findDomFromVNode(b[nextPos], true) : anchor, mountedQueue);
            }
        }
    }
}
var result;
var p;
var maxLen = 0;
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function lisAlgorithm(arr) {
    var arrI = 0;
    var i = 0;
    var j = 0;
    var k = 0;
    var u = 0;
    var v = 0;
    var c = 0;
    var len = arr.length;
    if (len > maxLen) {
        maxLen = len;
        result = new Int32Array(len);
        p = new Int32Array(len);
    }
    for (; i < len; ++i) {
        arrI = arr[i];
        if (arrI !== 0) {
            j = result[k];
            if (arr[j] < arrI) {
                p[i] = j;
                result[++k] = i;
                continue;
            }
            u = 0;
            v = k;
            while (u < v) {
                c = (u + v) >> 1;
                if (arr[result[c]] < arrI) {
                    u = c + 1;
                }
                else {
                    v = c;
                }
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) {
                    p[i] = result[u - 1];
                }
                result[u] = i;
            }
        }
    }
    u = k + 1;
    v = result[u - 1];
    var seq = new Int32Array(u);
    while (u-- > 0) {
        seq[u] = v;
        v = p[v];
        result[u] = 0;
    }
    return seq;
}

/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') {
    if (hasDocumentAvailable && !document.body) {
        error('Intact warning: you cannot initialize intact without "document.body".' +
            ' Wait on "DOMContentLoaded" event, add script to bottom of body,' +
            ' or use async/defer attributes on script tag.');
    }
}
var documentBody = null;
if (hasDocumentAvailable) {
    documentBody = document.body;
    /*
    * Defining $EV and $V properties on Node.prototype
    * fixes v8 "wrong map" de-optimization
    */
    if (window.Node) {
        var prototype = Node.prototype;
        prototype.$EV = null; // event
        prototype.$V = null; // vNode
        // v-model
        prototype.$M = null; // model
        prototype.$TV = null; // trueValue
        prototype.$FV = null; // falseValue
        prototype.$VA = null; // value
        // Transtion Element
        prototype.$TC = undefined;
        prototype.$TD = undefined;
        prototype.$ID = undefined;
        prototype._enterCb = undefined;
        prototype._leaveCb = undefined;
        prototype._moveCb = undefined;
    }
}
function render(vNode, parentDom) {
    if (process.env.NODE_ENV !== 'production') {
        if (documentBody === parentDom) {
            throwError('you cannot render() to the "document.body". Use an empty element as container instead.');
        }
        if (isInvalid(parentDom)) {
            throwError("render target (DOM) is mandatory, received ".concat(parentDom === null ? 'null' : typeof parentDom));
        }
    }
    var mountedQueue = [];
    var lastVNode = parentDom.$V;
    if (isNullOrUndefined(lastVNode)) {
        if (!isNullOrUndefined(vNode)) {
            if (vNode.type & 8192 /* InUse */) {
                vNode = directClone(vNode);
            }
            mount(vNode, parentDom, null, false, null, mountedQueue);
            parentDom.$V = vNode;
        }
    }
    else {
        if (isNullOrUndefined(vNode)) {
            remove(lastVNode, parentDom, false);
            parentDom.$V = null;
        }
        else {
            if (vNode.type & 8192 /* InUse */) {
                vNode = directClone(vNode);
            }
            patch(lastVNode, vNode, parentDom, null, false, null, mountedQueue, false);
            parentDom.$V = vNode;
        }
    }
    callAll(mountedQueue);
}

function isText(o) {
    return (o.type & 1 /* Text */) > 0;
}
function isElement(o) {
    return (o.type & 962 /* Element */) > 0;
}
function isComponentClass(o) {
    return (o.type & 8 /* ComponentClass */) > 0;
}
function isComponentFunction(o) {
    return (o.type & 16 /* ComponentFunction */) > 0;
}
function isFragment(o) {
    return (o.type & 4096 /* Fragment */) > 0;
}
function isComment(o) {
    return (o.type & 32 /* HtmlComment */) > 0;
}
function hasTextChildren(o) {
    return o.childrenType === 16 /* HasTextChildren */;
}
function hasInvalidChildren(o) {
    return o.childrenType === 1 /* HasInvalidChildren */;
}
function hasVNodeChildren(o) {
    return o.childrenType === 2 /* HasVNodeChildren */;
}
function hasMultipleChildren(o) {
    return (o.childrenType & 12 /* MultipleChildren */) > 0;
}

export { Fragment, VNode, callAll, createCommentVNode, createComponentVNode, createElementVNode, createFragment, createRef, createTextVNode, createUnescapeTextVNode, createUnknownComponentVNode, createVNode, createVoidVNode, directClone, findDomFromVNode, findDomsFromVNode, getTypeForVNodeElement, hasInvalidChildren, hasMultipleChildren, hasTextChildren, hasVNodeChildren, hooks, insertOrAppend, isComment, isComponentClass, isComponentFunction, isElement, isFragment, isText, linkEvent, mount, normalizeChildren, normalizeRoot, patch, remove, removeVNodeDom, render, unmount, unmountComponentClass, validateProps };
